import { TGroupBy } from '../../types/TGroupBy'

export const formatForTimeline = (groupBy: TGroupBy): TGroupBy | 'day' => {
    switch (groupBy) {
        case 'week':
            return 'day'
        case 'month':
            return 'week'
        case 'year':
            return 'month'
    }
}